import { ValidatorFn, FormArray } from '@angular/forms'


export function minArrayLengthValidator(minLength: number, message?: string): ValidatorFn {
  return (array: FormArray): {[key: string]: any} | null => {
    const length = array.controls.length
    const isValid = length >= minLength

    const params = {
      minlength: { 
        requiredLength: minLength, 
        actualLength: length 
      },
      message: message
    }
    
    console.log(array, params)
    return isValid ? null : params
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/core/forms/validators/min-array-length.validator.ts